import React from "react";
import { Stack, Typography, Button } from "@mui/material";
import TextInput from "../inputs/TextField";
import { useFormik } from "formik";
import * as Yup from "yup";

export interface ResetPasswordFormInterface {
  initialData: { password: string; newPassword: string };
  handleAction: (type: any, data: any) => void;
}

const SCHEMA = {
  password: Yup.string()
    .required("Please enter your password.")
    .min(8, "Your password is too short."),
  newPassword: Yup.string()
    .required("Please retype your password.")
    .oneOf([Yup.ref("password")], "Your passwords do not match."),
};
const ResetPasswordForm = ({
  handleAction,
  initialData,
}: ResetPasswordFormInterface) => {
  const { values, handleChange, handleBlur, handleSubmit, touched, errors } =
    useFormik({
      initialValues: initialData,
      validationSchema: Yup.object(SCHEMA),
      onSubmit: (value) => handleAction("submit", value),
    });
  return (
    <form onSubmit={handleSubmit} style={{ width: "100%", height: "100%" }}>
      <Stack
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        height="100%"
      >
        <Stack padding={2} spacing={3} textAlign="center">
          <Typography variant="h1" fontWeight={700}>
            New password
          </Typography>
          <Typography variant="h4" fontWeight={400}>
            Enter a new password with minimum of 8 characters, 1 symbol and 1
            number.
          </Typography>
        </Stack>
        <Stack spacing={2} width="100%">
          <TextInput
            label="Password"
            name="password"
            id="password"
            type="password"
            placeholder="Password"
            helperText={
              touched && touched.password ? errors && errors.password : ""
            }
            error={touched.password && Boolean(errors.password)}
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
          />

          <TextInput
            label="New Password"
            name="newPassword"
            id="newPassword"
            placeholder="Confirm Password"
            type="password"
            helperText={touched.newPassword ? errors.newPassword : ""}
            error={touched.newPassword && Boolean(errors.newPassword)}
            value={values.newPassword}
            onChange={handleChange}
            onBlur={handleBlur}
          />
        </Stack>
        <Stack
          spacing={3}
          width="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => handleSubmit()}
          >
            Save new Password
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
export default ResetPasswordForm;
